import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { NbSidebarService } from "@nebular/theme";
import { AzureService } from "./services/azure.service";
import { SetupService } from "./services/setup.service";
//v2-import { FullProfileService } from "./services/full-profile.service";
import { Globals } from "./globals";
import * as _ from "underscore";
import * as __ from "lodash";
import { environment } from "src/environments/environment";
import { MsalService } from "src/app/services/msal.service";
import { filter, take } from 'rxjs/operators';
import { firstValueFrom, combineLatest } from 'rxjs';
import { getRolesFromJWT } from "src/app/services/utils";
import { logging } from "protractor";


@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"],
    standalone: false
})
export class AppComponent {
  sidebarMenu = [];
  isPriority: boolean = false;
  canRegister: boolean = false;
  languageToggle: string = "English";

  constructor(
    private auth: MsalService,
    private router: Router,
    private sidebarService: NbSidebarService,
    private azureService: AzureService,
    private setupService: SetupService,
    //v2-private fullProfileService: FullProfileService,
    public globals: Globals
  ) {}

  async ngOnInit() {
    console.debug("APP Coponent - ngOnInit");
    await this.checkAuthentication();
    await this.loadMainConfiguration();
    
    // Subscribe to impersonation requests
    this.setupService.impersonateRequest$.subscribe(upn => {
      this.loadMainConfiguration(upn);
    });
    
    // await this.delay(3000);
    console.info("Current router URL: " + this.router.url)
    if (this.router.url === '/') {
      this.router.navigate(['home']);
    }
  }

  async checkAuthentication() {
    console.debug("Checking authentication");
    // Get the current user
    //v2-
    let token: any;
    if (environment.version != "2025b") {
      token = await this.azureService.getAzureToken();
    } else {
      token = await this.auth.login();
    }
    
    if (_.has(token, "error")) {
      this.router.navigate(["/error"]);
    }

    // Set the website's language
    if (this.globals.language == "french") {
      this.languageToggle = "English";
    } else {
      this.languageToggle = "Français";
    }
    this.setupService.tokenReady.next(true);
    // First call HAS to be unique in order not to create multiple users.
    // Thus this function will be called in a single promise, while the other ones are called together just after
  }

  async loadMainConfiguration(impersonatedUpn: string = "") {
    console.debug("Loading main config");
    let [headerResponse, getUser, stateResponse] = await Promise.all([
      this.setupService.getHeaders(),
      impersonatedUpn ? this.setupService.getUser(true, impersonatedUpn) : this.setupService.getUser(),
      this.setupService.getState()
      //v2-this.fullProfileService.getFullUserProfile(),
    ]);
    console.debug("Header response:", headerResponse);
    console.debug("User response:", getUser);
    console.debug("State response:", stateResponse);

    if (_.has(headerResponse, "error")) {
      this.router.navigate(["/error"]);
    } else {
      console.debug("Retrieving menu from static s3");
      this.globals.menu = this.setupService.applyLanguage(headerResponse).menu;
    }

    if (_.has(getUser, "error")) {
      this.router.navigate(["/error"]);
    } else {
      console.debug("User:", getUser)
      this.isPriority = this.setupService.user.priority;
      this.setupService.user.email = this.setupService.user.upn;
    }

    if (_.has(stateResponse, "error")) {
      if (stateResponse.error == "websiteClosed") {
        this.globals.state = "Closed";
        this.router.navigate(["/error"]);
      } else {
        this.router.navigate(["/error"]);
      }
    } else {
      this.globals.state = stateResponse;
    }

    if (this.globals.isAdmin || this.setupService.state.access.registration || this.isPriority) {
      this.setupService.state.access.registration = true;
    }
    await this.setSidebar();
  }

  impersonate(impersonatedUpn: string) {
    console.info(`IMPERSONATING ${impersonatedUpn}`)
    this.globals.impersonating = true;
    this.setupService.waitForUser(); 
    this.loadMainConfiguration(impersonatedUpn);
    this.setupService.userImpersonated$.next();
  }

  venezCommesVousEtes() {
    console.info(`Falling back to ${this.globals.userEmail}`)
    this.globals.impersonating = false;
    this.setupService.waitForUser(); 
    this.loadMainConfiguration(this.globals.userEmail);
    this.setupService.userImpersonated$.next();
  }

  rickRoll(){
    // Randomize the redirection to make it less obvious
    let rand = Math.random();
    if (rand < 0.33) {
      window.location.href = 'https://www.youtube.com/watch?v=dQw4w9WgXcQ';
    }
  }

  toggleSidebar() {
    this.sidebarService.toggle(true);
    return false;
  }

  async switchLanguage() {
    if (this.globals.language == "french") {
      this.globals.language = "english";
      this.languageToggle = "Français";
    } else {
      this.globals.language = "french";
      this.languageToggle = "English";
    }

    this.setupService.languageChanged$.next();
    // Plus besoin si les trad sont dans le meme json
    let [headerResponse] = await Promise.all([this.setupService.getHeaders()]);
    if (_.has(headerResponse, "error")) {
      this.router.navigate(["/error"]);
    } else {
      this.globals.menu = this.setupService.applyLanguage(headerResponse).menu;
      await this.setSidebar();
    }

    this.router.navigate([this.router.url]);
  }

  async setSidebar() {
    console.info("setSidebar - Waiting for userReady$")
    await firstValueFrom(
      this.setupService.userReady$.pipe(
        filter(ready => ready)
      )
    );
    console.info("setSidebar - lets go")
    console.info(this.setupService.user)

    this.sidebarMenu = __.cloneDeep(this.globals.menu);
    console.debug("Current sidebar menu: ", this.sidebarMenu);
    await firstValueFrom(
      this.setupService.userReady$.pipe(
        filter(ready => ready)
      )
    );
    if (!this.globals.isAdmin) {
      console.debug("User is not admin, hiding administration")
      this.sidebarMenu = __.reject(this.sidebarMenu, function (section) {
        return section.link == "admin";
      });
    } else {
      console.debug("User is admin")
    }
    if (!getRolesFromJWT(this.globals.token).includes("stalker")) {
      console.debug("User is not stalker, hiding stalking tab")
      this.sidebarMenu = __.reject(this.sidebarMenu, function (section) {
        return section.link == "stalker";
      });
    }
    
    console.debug("Setting sidebar for user: ", this.setupService.user)
    if (
      this.setupService.user.registration_state == "notStarted" ||
      this.setupService.user.registration_state == "quickProfile" ||
      this.setupService.user.waiting_list_number > 0
    ) {
      console.debug("User is not registered, hiding registration")
      this.sidebarMenu = __.reject(this.sidebarMenu, function (section) {
        return section.link == "registration";
      });
    } else {
      console.debug("User is registered, showing options");
      // We know where the bits are, no need to look for it
      let tempSidebar = __.cloneDeep(this.globals.menu[1]["children"]);

      console.debug("Sidebar is: ", tempSidebar);
      console.info(this.setupService.user.completed_registrations)
      tempSidebar[0].title = this.setupService.user.completed_registrations.includes("profile")        ? tempSidebar[0].title + " ️️✔️" : tempSidebar[0].title + " ❌";
      tempSidebar[1].title = this.setupService.user.completed_registrations.includes("transport") ? tempSidebar[1].title + " ️️✔️" : tempSidebar[1].title + " ❌";
      tempSidebar[2].title = this.setupService.user.activities.length > 0                              ? tempSidebar[2].title + " ️️✔️" : tempSidebar[2].title + " ➖";
      tempSidebar[3].title = this.setupService.user.completed_registrations.includes("skipass")        ? tempSidebar[3].title + " ️️✔️" : tempSidebar[3].title + " ❌";
      tempSidebar[4].title = this.setupService.user.completed_registrations.includes("equipment")      ? tempSidebar[4].title + " ️️✔️" : tempSidebar[4].title + " ❌";
      tempSidebar[5].title = this.setupService.user.completed_registrations.includes("terms")          ? tempSidebar[5].title + " ️️✔️" : tempSidebar[5].title + " ❌";
      tempSidebar[6].title = this.setupService.user.bedroom_id                                         ? tempSidebar[6].title + " ️️✔️" : tempSidebar[6].title + " ❌";
      console.debug("Updated didebar is: ", tempSidebar);
      // //  Profile
      // if (__.endsWith(tempSidebar[0].title, "❌") || __.endsWith(tempSidebar[0].title, "✔️")) {
      //   tempSidebar[0].title = this.setupService.user.completed_registrations["profile"]
      //     ? __.replace(tempSidebar[0].title, "❌", "️️️️️✔️")
      //     : __.replace(tempSidebar[0].title, "✔️", "❌");
      // } else {
      //   tempSidebar[0].title = this.setupService.user.completed_registrations["profile"] ? tempSidebar[0].title + " ️️✔️" : tempSidebar[0].title + " ❌";
      // }

      // //  Transports
      // if (__.endsWith(tempSidebar[1].title, "❌") || __.endsWith(tempSidebar[1].title, "✔️")) {
      //   tempSidebar[1].title = this.setupService.user.completed_registrations["transportation"]
      //     ? __.replace(tempSidebar[1].title, "❌", "️️️️️✔️")
      //     : __.replace(tempSidebar[1].title, "✔️", "❌");
      // } else {
      //   tempSidebar[1].title = this.setupService.user.completed_registrations["transportation"] ? tempSidebar[1].title + " ️️✔️" : tempSidebar[1].title + " ❌";
      // }

      // //  Activities
      // if (__.endsWith(tempSidebar[2].title, "➖") || __.endsWith(tempSidebar[2].title, "✔️")) {
      //   tempSidebar[2].title =
      //     this.setupService.user.activities.length > 0 ? __.replace(tempSidebar[2].title, "➖", "️️️️️✔️") : __.replace(tempSidebar[2].title, "✔️", "➖");
      // } else {
      //   tempSidebar[2].title = this.setupService.user.activities.length > 0 ? tempSidebar[2].title + " ️️✔️" : tempSidebar[2].title + " ➖";
      // }

      // //  Pass
      // if (__.endsWith(tempSidebar[3].title, "❌") || __.endsWith(tempSidebar[3].title, "✔️")) {
      //   tempSidebar[3].title = this.setupService.user.completed_registrations["pass"]
      //     ? __.replace(tempSidebar[3].title, "❌", "️️️️️✔️")
      //     : __.replace(tempSidebar[3].title, "✔️", "❌");
      // } else {
      //   tempSidebar[3].title = this.setupService.user.completed_registrations["pass"] ? tempSidebar[3].title + " ️️✔️" : tempSidebar[3].title + " ❌";
      // }

      // //  Equipment
      // if (__.endsWith(tempSidebar[4].title, "❌") || __.endsWith(tempSidebar[4].title, "✔️")) {
      //   tempSidebar[4].title = this.setupService.user.completed_registrations["equipment"]
      //     ? __.replace(tempSidebar[4].title, "❌", "️️️️️✔️")
      //     : __.replace(tempSidebar[4].title, "✔️", "❌");
      // } else {
      //   tempSidebar[4].title = this.setupService.user.completed_registrations["equipment"] ? tempSidebar[4].title + " ️️✔️" : tempSidebar[4].title + " ❌";
      // }

      // //  Terms
      // if (__.endsWith(tempSidebar[5].title, "❌") || __.endsWith(tempSidebar[5].title, "✔️")) {
      //   tempSidebar[5].title = this.setupService.user.completed_registrations["terms"]
      //     ? __.replace(tempSidebar[5].title, "❌", "️️️️️✔️")
      //     : __.replace(tempSidebar[5].title, "✔️", "❌");
      // } else {
      //   tempSidebar[5].title = this.setupService.user.completed_registrations["terms"] ? tempSidebar[5].title + " ️️✔️" : tempSidebar[5].title + " ❌";
      // }

      // //  Bedroom
      // if (__.endsWith(tempSidebar[6].title, "❌") || __.endsWith(tempSidebar[6].title, "✔️")) {
      //   //v2-bedroom.number changed to bedroom_id: need to make change globally
      //   tempSidebar[6].title = !__.isNull(this.setupService.user.bedroom_id)
      //     ? __.replace(tempSidebar[6].title, "❌", "️️️️️✔️")
      //     : __.replace(tempSidebar[6].title, "✔️", "❌");
      // } else {
      //   tempSidebar[6].title = !__.isNull(this.setupService.user.bedroom_id) ? tempSidebar[6].title + " ️️✔️" : tempSidebar[6].title + " ❌";
      // }

      this.sidebarMenu[1]["children"] = __.cloneDeep(tempSidebar);
      this.sidebarMenu[1]["expanded"] = true;
      console.debug("Final sidebar menu:", this.sidebarMenu);
    }
  }

  async delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

}
